<!-- 荣誉墙 -->
<template>
  <div class="honor">
    <el-row :gutter="20">
      <el-col
        :xs="24"
        :sm="24"
        :md="6"
        :lg="6"
        :xl="6"
        v-for="(item, index) in dataList"
        :key="index"
      >
        <div class="div" @click="jumpD(item.id)">
          <img :src="item.file" :alt="item.name" v-if="item.file != ''" />
        </div>
        <p>{{ item.name }}</p>
      </el-col>
    </el-row>

    <el-pagination
      style="text-align:center;margin-top:35px"
      v-if="dataList != null && total > 0"
      background
      layout="prev, pager, next"
      :total="total"
      :page-size="20"
      @current-change="handleCurrentChange"
      @prev-click="handleCurrentChange"
      @next-click="handleCurrentChange"
    >
    </el-pagination>
  </div>
</template>

<script>
import { getDataList } from "@/api/home";
import { getActive, setActive, removeActive } from "@/utils/auth";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      page: 1,
      total: 0,
      dataList: [],
    };
  },
  //监听属性 类似于data概念
  computed: {
    device() {
      return this.$store.state.app.device;
    },
  },
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    handleCurrentChange(val) {
      this.page = val;
      this.fetchData();
    },
    jumpD(id) {
      this.$router.push({
        path: "/overview/wall-famed",
        query: {
          id: id,
        },
      });
      setActive("2-3");
      this.$store.dispatch("user/setActive", "2-3");
    },
    fetchData() {
      let params1 = {
        page: this.page,
        type: 5,
      };
      getDataList(params1).then((response) => {
        this.dataList = response.data;
        this.total = response.total;
      });
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.fetchData();
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
};
</script>
<style lang="scss" scoped>
.honor {
  height: 100%;
  padding-top: 45px;
  padding-bottom: 50px;
  .div {
    width: 100%;
    height: 250px;
    cursor: pointer;
    img {
      width: 100%;
      height: 100%;
      background-color: #035bb1;
    }
  }
  p {
    text-align: center;
    font-size: 14px;
    margin-top: 15px;
    margin-bottom: 20px;
  }
  .pagination {
    margin-top: 35px;
    height: 45px;
  }
}
</style>
